import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { Navigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme";
import Layout from "./components/Layout/Layout";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import PrivateRoute from "./routes/PrivateRoute";
import { AuthProvider, useAuthContext } from "./context/AuthProvider";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Importación de TODOS los componentes posibles
import VentanasPage from "./pages/admin/VentanasPage";
import FuncionesPage from "./pages/admin/FuncionesPage";
import RolesPage from "./pages/admin/RolesPage";
import PersonasPage from "./pages/administracion/PersonasPage";
import EmpleadosPage from "./pages/admin/EmpleadosPage";
import TaxiEquiposPage from "./pages/administration/TaxiEquiposPage";
import VehiculosPage from "./pages/administracion/VehiculosPage";
import DocumentosPage from "./pages/administracion/DocumentosPage";
import TipoDocumentosPage from "./pages/administracion/TipoDocumentosPage";
import OrganizacionesPage from "./pages/administracion/OrganizacionesPage";
import ProyectosPage from "./pages/administracion/ProyectosPage";
import ProyectoDocumentosPage from "./pages/administracion/ProyectoDocumentosPage";
import ManifiestosPage from "./pages/administracion/ManifiestosPage";
import ManifiestoDetallesPage from "./pages/administracion/ManifiestoDetallesPage";
import ManifiestoHistorialPage from "./pages/administracion/ManifiestoHistorialPage";
import LocalizacionesPage from "./pages/administracion/LocalizacionesPage";
import RutasPage from "./pages/administracion/RutasPage";
import EmpleadosHabilitacionPage from "./pages/administracion/EmpleadosHabilitacionPage";
import VehiculosHabilitacionPage from "./pages/administracion/VehiculosHabilitacionPage";
import EmpleadoDetallePage from "./pages/admin/EmpleadoDetallePage";
import VehiculoDetallePage from "./pages/administracion/VehiculoDetallePage";
import OrganizacionesProveedorPage from "./pages/administracion/OrganizacionesProveedorPage";
import AgendaPage from "./pages/administracion/AgendaPage";
import MonitorViajePage from "./pages/administration/MonitorViajePage";
import MonitorAllManifestPage from "./pages/administration/MonitorAllManifestPage";
/*========ADMINISTRACION===============*/
import TiposServiciosPage from "./pages/administration/TiposServiciosPage";
import TaxiTiposServiciosPage from "./pages/administration/TaxiTiposServiciosPage";
import TiposServiciosProyectoPage from "./pages/administration/TiposServiciosProyectoPage";
import OrdenesServiciosPage from "./pages/administration/OrdenesServiciosPage";
import ClienteOrdenServicioPage from "./pages/administration/ClienteOrdenServicioPage";
import ServicioDetallePage2 from "./pages/administration/ServicioDetallePage2";
import ServicioHistorialPage from "./pages/administration/ServicioHistorialPage";
import ManifiestosInternosPage from "./pages/administration/ManifiestosInternosPage";
import ManifiestosExternosPage from "./pages/administration/ManifiestosExternosPage";
import ManifiestosTaxiPage from "./pages/administration/ManifiestosTaxiPage";
import ValorizacionesPage from "./pages/administration/ValorizacionesPage";
import ValorizacionDetallePage from "./pages/administration/ValorizacionDetallePage";
//=======CLIENTE========//
import ViajesClientePage from "./pages/cliente/ViajesClientePage";
import ViajesClienteDetailPage from "./pages/cliente/ViajesClienteDetailPage";
//======MANTENIMIENTO======//
import TiposMantenimientoPage from "./pages/mantenimiento/TiposMantenimientoPage";
import TiposComponentePage from "./pages/mantenimiento/TiposComponentePage";
import ComponentesVehiculoPage from "./pages/mantenimiento/ComponentesVehiculoPage";
import MantenimientosComponentePage from "./pages/mantenimiento/MantenimientosComponentePage";
import MantenimientoDetallePage from "./pages/mantenimiento/MantenimientoDetallePage";
import SistemasVehiculoPage from "./pages/mantenimiento/SistemasVehiculoPage";
import MantenimientosVehiculoPage from "./pages/mantenimiento/MantenimientosVehiculoPage";
import MantenimientosVehiculoDetallePage from "./pages/mantenimiento/MantenimientoVehiculoDetallePage";
//======CONTABILIDAD=======//
import TiposComprobantePage from "./pages/contabilidad/TiposComprobantePage";
//======REPORTES=======//
import ReportesOrdenServicioPage from "./pages/management/ReportesOrdenServicioPage";
import ReporteManifiestoTrackingPage from "./pages/reports/ReporteManifiestoTrackingPage";

// 🔹 Mapeo de TODOS los componentes disponibles
const componentesDisponibles = {
  Dashboard,
  VentanasPage,
  FuncionesPage,
  RolesPage,
  PersonasPage,
  EmpleadosPage,
  VehiculosPage,
  TaxiEquiposPage,
  DocumentosPage,
  TipoDocumentosPage,
  OrganizacionesPage,
  ProyectosPage,
  ProyectoDocumentosPage,
  ManifiestosPage,
  ManifiestoDetallesPage,
  ManifiestoHistorialPage,
  LocalizacionesPage,
  RutasPage,
  EmpleadosHabilitacionPage,
  VehiculosHabilitacionPage,
  EmpleadoDetallePage,
  VehiculoDetallePage,
  OrganizacionesProveedorPage,
  AgendaPage,
  MonitorViajePage,
  MonitorAllManifestPage,
  //-----Modulo para el cliente-----//
  ViajesClientePage,
  ViajesClienteDetailPage,
  //-----Modulo de Mantenimeinto-----//
  TiposMantenimientoPage,
  TiposComponentePage,
  ComponentesVehiculoPage,
  MantenimientosComponentePage,
  MantenimientoDetallePage,
  SistemasVehiculoPage,
  MantenimientosVehiculoPage,
  MantenimientosVehiculoDetallePage,
  //-----Modulo de Contabilidad-----//
  TiposComprobantePage,
  /*====Modulo Administracion======*/
  TiposServiciosPage,
  TaxiTiposServiciosPage,
  TiposServiciosProyectoPage,
  OrdenesServiciosPage,
  ClienteOrdenServicioPage,
  ServicioDetallePage2,
  ServicioHistorialPage,
  ManifiestosInternosPage,
  ManifiestosExternosPage,
  ManifiestosTaxiPage,
  ValorizacionesPage,
  ValorizacionDetallePage,
  //-----Modulo para reportes-----//
  ReportesOrdenServicioPage,
  ReporteManifiestoTrackingPage,
};

function AppContent() {
  //const { user, menu } = useAuthContext();
  const { user, menu = [], loading } = useAuthContext();
  const [drawerOpen, setDrawerOpen] = useState(true);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const drawerWidth = isSmallScreen ? 0 : 260;

  const contentPadding = {
    xs: 1,
    sm: 1.5,
    md: 2,
    lg: 2.5,
  };

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }} />
      </ThemeProvider>
    );
  }

  if (!user) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          {/*<Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/login" replace />} />*/}
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />          
        </Routes>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f5f5" }}>

        {user && <Sidebar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />}

        {/*<Box component="main" sx={{ flexGrow: 1, p: 3, marginLeft: user ? "240px" : "0px" }}>*/}
        <Box component="main"
          sx={{
            flexGrow: 1,
            p: contentPadding,
            transition: theme.transitions.create(["margin", "width"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: drawerOpen && !isSmallScreen ? `${drawerWidth}px` : 0,
            width: drawerOpen && !isSmallScreen ? `calc(100% - ${drawerWidth}px)` : "100%",
            overflowX: "auto",
            minHeight: "100vh",
            "& > *": {
              maxWidth: "100%",
            },
          }}
        >
          <Routes>    
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            {/*<Route path="/dashboard" element={<Dashboard />} />*/}
            <Route path="/login" element={<Navigate to="/dashboard" replace />} />

            {/*<Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/login" replace />} /> */}

            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              {menu.flatMap((funcion) =>
                funcion.ventanas.map((ventana) => {
                  const Componente = componentesDisponibles[ventana.VenCtr];
                  return Componente ? (
                    <Route key={ventana.VenID} path={ventana.VenURL} element={<Componente />} />
                  ) : null;
                })
              )}
            </Route>
          </Routes>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;